import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { DropdownList } from "components/common/dropdown/DropdownList.component";
import { Button } from "components/common/Button.component";
import { IDropdownButton } from "types/gaiaComponents/dropdownButton";
import { ICON_SIZE, KEY } from "components/common/constants";

export const DropdownButton = (props: IDropdownButton) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };

        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === KEY.ESCAPE) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [dropdownOpen]);

    const onClickDropdown = function (e: React.MouseEvent<HTMLButtonElement>) {
        setDropdownOpen(!dropdownOpen);
    }

    const defaultIcon = () => {
        return dropdownOpen ? <ChevronUpIcon size={ICON_SIZE.MEDIUM} /> : <ChevronDownIcon size={ICON_SIZE.MEDIUM} />
    }

    return (
        <div ref={dropdownRef}
             className={`ga-native-select dropdown--button`}>
            <Button
                id={props.id}
                type={props.type}
                text={props.text}
                title={props.title}
                icon={props.icon}
                iconOnly={!props.text}
                rightIcon={props.text ? defaultIcon() : null}
                disabled={props.disabled}
                onClick={onClickDropdown}
                tabIndex={dropdownOpen ? -1 : 0}
            />
            {dropdownOpen && !props.isEmpty &&
                <DropdownList items={props.items.map(item => ({
                    ...item,
                    onClick: () => {
                        if (item.onClick) item.onClick();
                        setDropdownOpen(false);
                    }
                }))} position={props.position} />
            }
        </div>
    )
}